import { useCallback, useRef, useState } from 'react';
import { ajouterActif } from '../utils/ajoutActif';

/**
 * « Ajouter un actif » avec un seul envoi à la fois.
 *
 * POURQUOI (relectures du lot L2, 26/10). Le serveur interroge maintenant l'appareil
 * avant de créer l'actif : l'appel dure une à plusieurs secondes. Sans verrou, un double
 * clic envoyait deux POST, et David voyait un 409 « déjà rattaché » juste après le toast
 * de succès du premier. Le verrou est une référence, pas seulement l'état : deux clics
 * dans le même rendu verraient encore `enCours` à faux.
 *
 * `url` et `prefixe` (lot L4) : la fiche chantier du distributeur s'en sert aussi.
 */
export default function useAjoutActif({ api, toast, url, prefixe }) {
  const [enCours, setEnCours] = useState(false);
  const verrou = useRef(false);
  const ajouter = useCallback(async (clientId, actif) => {
    if (verrou.current) return false;
    verrou.current = true;
    setEnCours(true);
    try {
      return await ajouterActif({ api, toast, clientId, actif, url, prefixe });
    } finally {
      verrou.current = false;
      setEnCours(false);
    }
  }, [api, toast, url, prefixe]);
  return { enCours, ajouter };
}
